import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import { ControllerDetails } from '#services/cve/ControllerDetails';

export const errorsMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/CompanyGrade$',
    },
    response: {
      status: 500,
      body: {},
      headers: {
        traceparent: '00-toto',
      },
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/EnergyPolicy$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'EnergyPolicy',
        statusCode: ControllerStatus.CHECKING,
        check: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          controlData: {},
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'POST',
      urlPathPattern: '^/iterations.*$',
    },
    response: {
      status: 500,
      body: {},
      headers: {
        traceparent: '00-toto',
      },
    },
  },
  {
    request: {
      method: 'POST',
      urlPathPattern: '^/customerVettingJourney',
    },
    response: {
      status: 500,
      body: {},
    },
  },
];
